/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

export const TimeBasedItemType = Object.freeze({
	ACTION_ITEM: 'ACTION_ITEM',
	PROSPECT: 'PROSPECT',
})
export const TimeBasedItemName = Object.freeze({
	ACTION_ITEM: 'Action Item',
	PROSPECT: 'Prospect',
})


